// Angular
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
// RxJS
import { Observable, Subject } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { Router } from '@angular/router';
import { decrypt, encrypt } from '../../../../../utilities/utilityFunctions';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { Idle } from '@ng-idle/core';

@Component({
	selector: 'kt-user-profile2',
	templateUrl: './user-profile2.component.html',
})
export class UserProfile2Component implements OnInit {
	@Input() avatar:any = HEC_CONSTANTS.CONSTANT_VALUES.DEFAULT_IMG_PATH;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;
	public loggedInUserEmail: any;
	public loggedInUserFullName: any;
	constructor(private store: Store<AppState>, private sharedServices: SharedService,
		private cdr:ChangeDetectorRef, private router: Router,private idle: Idle,) {
			let data = decrypt(localStorage.getItem('esp-profile-details'));
		data = JSON.parse(data);
		this.loggedInUserEmail = data['email'];
		this.loggedInUserFullName = data['fullName'];
    localStorage.setItem('name',encrypt(this.loggedInUserFullName))
		if(localStorage.getItem('Avatar') == undefined){
			this.getUserPicture();
			}else{
				this.avatar = decrypt(localStorage.getItem('Avatar'));
			}
	}


	ngOnInit(): void {
		setInterval(()=>{
			this.checkUpdateStatus();
		if(localStorage.getItem('Avatar')!= undefined){
			this.checkPictureStatus();
		}
	}, 500);
	}

public checkPictureStatus(): void {	
				let token = localStorage.getItem('Avatar');
				if(token == null) {
						this.avatar = HEC_CONSTANTS.CONSTANT_VALUES.DEFAULT_IMG_PATH;
						this.cdr.detectChanges();						// If you are using router
						
				}else{
				this.avatar = decrypt(localStorage.getItem('Avatar'));
				this.cdr.markForCheck();
				}
			}		

			public checkUpdateStatus(): void {
				if(localStorage.getItem('updateInfo') != undefined){
				let data = decrypt(localStorage.getItem('esp-profile-details'));
				data = JSON.parse(data);	
				this.loggedInUserEmail = data['email'];
				this.loggedInUserFullName = data['fullName'];
				this.cdr.detectChanges();
				localStorage.removeItem('updateInfo');
				}
			}

	public getUserPicture() {
		this.sharedServices.getUserProfilePicture().subscribe(
			(res) => {
				if (res.statusCode == 200) {
					if(res.data != ''){
					this.avatar = res.data;
					try {
						// Large encrypted avatars can exceed localStorage quota; keep in-memory only.
						if (this.avatar && this.avatar.length <= 1200000) {
							const encrypted = encrypt(this.avatar);
							if (encrypted && encrypted.length <= 1800000) {
								localStorage.removeItem('Avatar');
								localStorage.setItem('Avatar', encrypted);
							}
						}
					} catch (e) {
						try { localStorage.removeItem('Avatar'); } catch (_) {}
					}
					this.cdr.detectChanges();
				}else{
				this.avatar = HEC_CONSTANTS.CONSTANT_VALUES.DEFAULT_IMG_PATH;
				}
				}
			},
			(err) =>{
				this.logout();
			}
		)
	}

	public logout() {
		this.sharedServices.logoutUser().subscribe(
			(res) => {
				if (res['statusCode'] == 200) {
					localStorage.removeItem('esp-profile-details');
					localStorage.removeItem('ng2Idle.main.expiry');
					localStorage.removeItem('eduHistory');
					localStorage.removeItem('dob');
					localStorage.removeItem('loginDetails');
					localStorage.removeItem('addresses');
					localStorage.removeItem('primaryNationality');
					localStorage.removeItem('name');
					localStorage.removeItem('Avatar');
					localStorage.removeItem('isForeign');
					localStorage.removeItem('login');
					localStorage.removeItem('userInfo');
					this.idle.stop();
					document.cookie = "profile=; _ga=0; path=/"
					this.router.navigate(['/auth/login'])
				}
			}
		)
	}
}
